<ngb-toast
    [delay]="toast.timeout"
    [autohide]="toast.dismissOnTimeout"
    [ngClass]="getToastTheme(toast)"
    (hidden)="onHidden(toast)">

    <div class="d-flex align-items-start gap-2">

        <div class="icon-container d-flex align-items-center justify-content-center">
            @if (toast.theme === 'downloading') {
                <fdx-spinner size="sm" [ngClass]="getIconTheme(toast)"></fdx-spinner>
            } @else {
                <fa-icon [icon]="toast.icon" size="lg" [ngClass]="getIconTheme(toast)"/>
            }
        </div>

        <div class="vstack">
            @if (toast.title) {
                <div class="fs-5 fw-semibold mb-1">{{ toast.title }}</div>
            }

            @if (toast.contentIsHtml) {
                <div class="html-toast-content" [innerHTML]="toast.content"></div>
            } @else {
                <div class="white-space-pre-line">{{ toast.content }}</div>
            }

            @if (toast.buttons?.length) {
                <div class="d-flex flex-wrap gap-2 mt-2">
                    @for (button of toast.buttons; track button.name) {
                        <button
                            [attr.name]="button.name"
                            type="button"
                            class="btn"
                            [disabled]="(button.disabled && button.disabled()) ?? false"
                            [ngClass]="getButtonClasses(toast, button, $index)"
                            (click)="buttonClick($event, button)">

                            @if (button.icon && button.iconPosition === 'left') {
                                <fa-icon [icon]="button.icon"/>
                            }

                            <span>{{ button.text }}</span>

                            @if (button.icon && button.iconPosition === 'right') {
                                <fa-icon [icon]="button.icon" class="fa-icon-right"/>
                            }
                        </button>
                    }
                </div>
            }
        </div>

        <div>
            <button type="button" class="btn btn-ghost btn-sq" (click)="closeToast(toast.id)">
                <fa-icon [icon]="closeIcon" size="sm" class="no-margin"/>
            </button>
        </div>

    </div>
</ngb-toast>
